import React from 'react';
import './FontAwesomeIcons.css';

const FontAwesomeIcons = () => {
    return (
        <div className="fa-icons__wrapper">
            <section>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
                <div className="fa-icons__row">
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                    <div>
                        <i className="fa fa-address-book-o"></i>
                        <i className="fa fa-bath"></i>
                        <i className="fa fa-shower"></i>
                        <i className="fa fa-thermometer-half"></i>
                        <i className="fa fa-balance-scale"></i>
                        <i className="fa fa-battery-half"></i>
                        <i className="fa fa-bell-o"></i>
                        <i className="fa fa-bicycle"></i>
                        <i className="fa fa-bolt"></i>
                        <i className="fa fa-bullhorn"></i>
                        <i className="fa fa-commenting-o"></i>
                        <i className="fa fa-comments-o"></i>
                        <i className="fa fa-envelope-o"></i>
                        <i className="fa fa-gift"></i>
                        <i className="fa fa-glass"></i>
                        <i className="fa fa-globe"></i>
                        <i className="fa fa-graduation-cap"></i>
                        <i className="fa fa-heart-o"></i>
                        <i className="fa fa-hourglass-end"></i>
                        <i className="fa fa-twitter"></i>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default FontAwesomeIcons
